import React, { useRef, useState, useEffect } from 'react';
import { Search, Tune, Close, LocationOn } from '@mui/icons-material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Box,
  IconButton,
  InputBase,
  Paper,
  Menu,
  Typography,
  Divider,
  Slider,
  Button,
  Popper,
  ClickAwayListener,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { GOOGLEMAPS_API_KEY } from '../../Api/ApiUrls';

// Price ranges based on current path
const getPriceRanges = (path) => {
const purchaseRanges = [
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 20L', min: 1000000, max: 2000000 },
  { label: '20L - 30L', min: 2000000, max: 3000000 },
  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
  { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },

  { label: '6CR - 8CR', min: 60000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
  { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
  { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
  { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
  { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
  { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
  { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
  { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
  { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
  { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
  { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
{ label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
{ label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
{ label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
{ label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
{ label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
{ label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
{ label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
{ label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
{ label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },

{ label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
{ label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
{ label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
{ label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
{ label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
{ label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
{ label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
{ label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
{ label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
{ label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },

{ label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 }];

const rentRanges = [
  // { label: 'No Min', min: 0, max: 0 },

  { label: '1K - 2K', min: 1000, max: 2000 },
  { label: '2K - 3K', min: 2000, max: 3000 },
  { label: '3K - 4K', min: 3000, max: 4000 },
  { label: '4K - 5K', min: 4000, max: 5000 },
  { label: '5K - 10K', min: 5000, max: 10000 },
  { label: '10K - 15K', min: 10000, max: 15000 },
  { label: '15K - 20K', min: 15000, max: 20000 },
  { label: '20K - 25K', min: 20000, max: 25000 },
  { label: '25K - 30K', min: 25000, max: 30000 },
  { label: '30K - 35K', min: 30000, max: 35000 },
  { label: '35K - 40K', min: 35000, max: 40000 },
  { label: '40K - 50K', min: 40000, max: 50000 },
  { label: '50K - 60K', min: 50000, max: 60000 },
  { label: '60K - 70K', min: 60000, max: 70000 },
  { label: '70K - 80K', min: 70000, max: 80000 },
  { label: '80K - 90K', min: 80000, max: 90000 },
  { label: '90K - 1L', min: 90000, max: 100000 },

  { label: '1L - 1.25L', min: 100000, max: 125000 },
  { label: '1.25L - 1.5L', min: 125000, max: 150000 },
  { label: '1.5L - 2L', min: 150000, max: 200000 },
  { label: '2L - 2.5L', min: 200000, max: 250000 },
  { label: '2.5L - 3L', min: 250000, max: 300000 },
  { label: '3L - 3.5L', min: 300000, max: 350000 },
  { label: '3.5L - 4L', min: 350000, max: 400000 },
  { label: '4L - 4.5L', min: 400000, max: 450000 },
  { label: '4.5L - 5L', min: 450000, max: 500000 },
  { label: '5L - 6L', min: 500000, max: 600000 },
  { label: '6L - 7L', min: 600000, max: 700000 },
  { label: '7L - 8L', min: 700000, max: 800000 },
  { label: '8L - 9L', min: 800000, max: 900000 },
  { label: '9L - 10L', min: 900000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },

  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.2CR', min: 10000000, max: 12000000 },
  { label: '1.2CR - 1.4CR', min: 12000000, max: 14000000 },
  { label: '1.4CR - 1.6CR', min: 14000000, max: 16000000 },
  { label: '1.6CR - 1.8CR', min: 16000000, max: 18000000 },
  { label: '1.8CR - 2CR', min: 18000000, max: 20000000 },

  { label: '2CR - 2.2CR', min: 20000000, max: 22000000 },
  { label: '2.2CR - 2.4CR', min: 22000000, max: 24000000 },
  { label: '2.4CR - 2.6CR', min: 24000000, max: 26000000 },
  { label: '2.6CR - 2.8CR', min: 26000000, max: 28000000 },
  { label: '2.8CR - 3CR', min: 28000000, max: 30000000 },

  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
  { label: '6CR - 6.5CR', min: 60000000, max: 65000000 },
  { label: '6.5CR - 7CR', min: 65000000, max: 70000000 },
  { label: '7CR - 7.5CR', min: 70000000, max: 75000000 },
  { label: '7.5CR - 8CR', min: 75000000, max: 80000000 },
  { label: '8CR - 8.5CR', min: 80000000, max: 85000000 },
  { label: '8.5CR - 9CR', min: 85000000, max: 90000000 },
  { label: '9CR - 9.5CR', min: 90000000, max: 95000000 },
  { label: '9.5CR - 10CR', min: 95000000, max: 100000000 },

  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 30CR', min: 200000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR+++', min: 1000000000, max: 9999999999 }
];

  const leaseRanges = [
  // { label: 'No Min', min: 0, max: 0 },

  { label: '1L - 2L', min: 100000, max: 200000 },
  { label: '2L - 3L', min: 200000, max: 300000 },
  { label: '3L - 4L', min: 300000, max: 400000 },
  { label: '4L - 5L', min: 400000, max: 500000 },
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },
  { label: '30L - 35L', min: 3000000, max: 3500000 },
  { label: '35L - 40L', min: 3500000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 2CR', min: 15000000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 6CR', min: 50000000, max: 60000000 },
  { label: '6CR - 7CR', min: 60000000, max: 70000000 },
  { label: '7CR - 8CR', min: 70000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },

  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },

  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR+++', min: 1000000000, max: 9999999999 }
];

    if (path.includes('/buy-map', "/postbank-card")) {
      return purchaseRanges;
    } else if (path.includes('/rent-propertymap')) {
      return rentRanges;
    } else if (path.includes('/lease_map')) {
      return leaseRanges;
    }
  
  return purchaseRanges; 
};

const getRangeButtons = (path) => {
  const purchaseRangeButtons = [
   { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 20L', min: 1000000, max: 2000000 },
  { label: '20L - 30L', min: 2000000, max: 3000000 },
  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
  { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },

  { label: '6CR - 8CR', min: 60000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
  { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
  { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
  { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
  { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
  { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
  { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
  { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
  { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
  { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
  { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
{ label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
{ label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
{ label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
{ label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
{ label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
{ label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
{ label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
{ label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
{ label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },

{ label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
{ label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
{ label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
{ label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
{ label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
{ label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
{ label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
{ label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
{ label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
{ label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },

{ label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 }];


const rentRangeButtons = [
   { label: '1K - 2K', min: 1000, max: 2000 },
  { label: '2K - 3K', min: 2000, max: 3000 },
  { label: '3K - 4K', min: 3000, max: 4000 },
  { label: '4K - 5K', min: 4000, max: 5000 },
  { label: '5K - 10K', min: 5000, max: 10000 },
  { label: '10K - 15K', min: 10000, max: 15000 },
  { label: '15K - 20K', min: 15000, max: 20000 },
  { label: '20K - 25K', min: 20000, max: 25000 },
  { label: '25K - 30K', min: 25000, max: 30000 },
  { label: '30K - 35K', min: 30000, max: 35000 },
  { label: '35K - 40K', min: 35000, max: 40000 },
  { label: '40K - 50K', min: 40000, max: 50000 },
  { label: '50K - 60K', min: 50000, max: 60000 },
  { label: '60K - 70K', min: 60000, max: 70000 },
  { label: '70K - 80K', min: 70000, max: 80000 },
  { label: '80K - 90K', min: 80000, max: 90000 },
  { label: '90K - 1L', min: 90000, max: 100000 },

  { label: '1L - 1.25L', min: 100000, max: 125000 },
  { label: '1.25L - 1.5L', min: 125000, max: 150000 },
  { label: '1.5L - 2L', min: 150000, max: 200000 },
  { label: '2L - 2.5L', min: 200000, max: 250000 },
  { label: '2.5L - 3L', min: 250000, max: 300000 },
  { label: '3L - 3.5L', min: 300000, max: 350000 },
  { label: '3.5L - 4L', min: 350000, max: 400000 },
  { label: '4L - 4.5L', min: 400000, max: 450000 },
  { label: '4.5L - 5L', min: 450000, max: 500000 },
  { label: '5L - 6L', min: 500000, max: 600000 },
  { label: '6L - 7L', min: 600000, max: 700000 },
  { label: '7L - 8L', min: 700000, max: 800000 },
  { label: '8L - 9L', min: 800000, max: 900000 },
  { label: '9L - 10L', min: 900000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },

  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.2CR', min: 10000000, max: 12000000 },
  { label: '1.2CR - 1.4CR', min: 12000000, max: 14000000 },
  { label: '1.4CR - 1.6CR', min: 14000000, max: 16000000 },
  { label: '1.6CR - 1.8CR', min: 16000000, max: 18000000 },
  { label: '1.8CR - 2CR', min: 18000000, max: 20000000 },

  { label: '2CR - 2.2CR', min: 20000000, max: 22000000 },
  { label: '2.2CR - 2.4CR', min: 22000000, max: 24000000 },
  { label: '2.4CR - 2.6CR', min: 24000000, max: 26000000 },
  { label: '2.6CR - 2.8CR', min: 26000000, max: 28000000 },
  { label: '2.8CR - 3CR', min: 28000000, max: 30000000 },

  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
  { label: '6CR - 6.5CR', min: 60000000, max: 65000000 },
  { label: '6.5CR - 7CR', min: 65000000, max: 70000000 },
  { label: '7CR - 7.5CR', min: 70000000, max: 75000000 },
  { label: '7.5CR - 8CR', min: 75000000, max: 80000000 },
  { label: '8CR - 8.5CR', min: 80000000, max: 85000000 },
  { label: '8.5CR - 9CR', min: 85000000, max: 90000000 },
  { label: '9CR - 9.5CR', min: 90000000, max: 95000000 },
  { label: '9.5CR - 10CR', min: 95000000, max: 100000000 },

  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 30CR', min: 200000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR+++', min: 1000000000, max: 9999999999 }
];

  const leaseRangeButtons = [
   { label: '1L - 2L', min: 100000, max: 200000 },
  { label: '2L - 3L', min: 200000, max: 300000 },
  { label: '3L - 4L', min: 300000, max: 400000 },
  { label: '4L - 5L', min: 400000, max: 500000 },
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },
  { label: '30L - 35L', min: 3000000, max: 3500000 },
  { label: '35L - 40L', min: 3500000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },

  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 2CR', min: 15000000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 6CR', min: 50000000, max: 60000000 },
  { label: '6CR - 7CR', min: 60000000, max: 70000000 },
  { label: '7CR - 8CR', min: 70000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },

  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },

  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },

  { label: '100CR+++', min: 1000000000, max: 9999999999 }
  ];

  if (path.includes('/buy-map')) {
    return purchaseRangeButtons;
  } else if (path.includes('/rent-propertymap')) {
    return rentRangeButtons;
  } else if (path.includes('/lease_map')) {
    return leaseRangeButtons;
  }
  
  return purchaseRangeButtons;
};



  
  const getInitialMax = (path) => {
  if (path.includes('/rent-propertymap')) return 9999999999;      // 100CR+++
  if (path.includes('/lease_map')) return 9999999999;             // 100CR+++
  return 100000000000;                                            // 10000CR+++ for buy-map
};
const CustomSearchBar = ({ 
  onPlaceSelected, 
  onClear, 
  onPriceFilterChange,
  selectedLocationText  // ← NEW PROP to receive location from parent
}) => {
  const location = useLocation();
  const [customRange, setCustomRange] = useState([0, getInitialMax(location.pathname)]);
  const [sliderMax, setSliderMax] = useState(getInitialMax(location.pathname));
  const navigate = useNavigate();
  
  const hidePriceFilter = location.pathname.includes('/home-service-type') ||
    location.pathname.includes('/home-service');

  const inputRef = useRef(null);
  const paperRef = useRef(null);
  const autocompleteRef = useRef(null);

  const [searchValue, setSearchValue] = useState('');
  const [recentSearches, setRecentSearches] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [tempSelectedRange, setTempSelectedRange] = useState(null);
  const [apiLoaded, setApiLoaded] = useState(false);
  const [suggestionsOpen, setSuggestionsOpen] = useState(false);
  const [predictions, setPredictions] = useState([]);

  const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY;

  // Get price ranges based on current path
  const currentPriceRanges = getPriceRanges(location.pathname);
  const currentRangeButtons = getRangeButtons(location.pathname);

  const formatPrice = (value) => {
    if (value === 0) return 'No Min';
    if (value >= 10000000) return `${value / 10000000} Cr`;
    if (value >= 100000) return `${value / 100000} L`;
    if (value >= 1000) return `${value / 1000} K`;
    return value;
  };

  // ✅ NEW: Update searchValue when selectedLocationText changes from parent
  useEffect(() => {
    if (selectedLocationText) {
      setSearchValue(selectedLocationText);
      // Also save to localStorage
      localStorage.setItem('savedSearchValue', selectedLocationText);
    }
  }, [selectedLocationText]);

  useEffect(() => {
    const savedSearch = localStorage.getItem('savedSearchValue');
    if (savedSearch) setSearchValue(savedSearch);

    const savedSearches = localStorage.getItem('recentLocationSearches');
    if (savedSearches) setRecentSearches(JSON.parse(savedSearches));

    if (window.google?.maps?.places) {
      setApiLoaded(true);
      initAutocomplete();
    } else {
      loadGoogleMapsAPI();
    }
  }, []);

  // Rest of your existing code remains the same...
  const loadGoogleMapsAPI = () => {
    if (document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`)) return;

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setApiLoaded(true);
      initAutocomplete();
    };
    document.head.appendChild(script);
  };

  const initAutocomplete = () => {
    if (!inputRef.current || !window.google?.maps?.places) return;

    autocompleteRef.current = new window.google.maps.places.AutocompleteService();

    const handleInputChange = () => {
      const value = inputRef.current?.value || '';
      setSearchValue(value);

      if (!value.trim()) {
        setPredictions([]);
        setSuggestionsOpen(false);
        return;
      }

      autocompleteRef.current.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: 'in' },
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setPredictions(predictions);
            setSuggestionsOpen(true);
          } else {
            setPredictions([]);
            setSuggestionsOpen(false);
          }
        }
      );
    };

    inputRef.current.addEventListener('input', handleInputChange);

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('input', handleInputChange);
      }
    };
  };

  const handlePlaceSelected = (place) => {
    if (!place.geometry) {
      const service = new window.google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails({ placeId: place.place_id }, (fullPlace, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          processPlace(fullPlace);
        }
      });
    } else {
      processPlace(place);
    }
  };

  const processPlace = (place) => {
    const locationData = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      address: place.formatted_address || place.name,
      name: place.name || place.formatted_address,
      radius: 10000,
    };

    setRecentSearches((prev) => [
      locationData,
      ...prev.filter((item) => item.address !== locationData.address).slice(0, 4),
    ]);

    if (onPlaceSelected) onPlaceSelected(locationData);
    setSearchValue(locationData.name);
    setSuggestionsOpen(false);
    setPredictions([]);
  };

  const handleSuggestionClick = (prediction) => {
    setSearchValue(prediction.description);
    setSuggestionsOpen(false);

    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({ placeId: prediction.place_id }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        handlePlaceSelected(place);
      }
    });
  };

  // Rest of your handlers remain the same...
  const handleTuneClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  useEffect(() => {
    if (anchorEl) setTempSelectedRange(selectedPriceRange);
  }, [anchorEl]);

  const handlePriceRangeSelectTemp = (range) => {
    setCustomRange([range.min, range.max]);
    setTempSelectedRange({
      label: range.label,
      min: range.min,
      max: range.max,
    });
    setSliderMax(range.max > sliderMax ? range.max : sliderMax);
  };

  const handleRangeButtonSelect = (range) => {
    setCustomRange([range.min, range.max]);
    setTempSelectedRange({
      label: range.label,
      min: range.min,
      max: range.max,
    });
    setSliderMax(range.max > sliderMax ? range.max : sliderMax);
  };

  const handleSliderChangeTemp = (e, newValue) => {
    setCustomRange(newValue);
    setTempSelectedRange({
      label: `${formatPrice(newValue[0])} - ${formatPrice(newValue[1])}`,
      min: newValue[0],
      max: newValue[1],
    });
    if (newValue[1] > sliderMax) setSliderMax(newValue[1]);
  };

  const handleApplyFilter = () => {
    setSelectedPriceRange(tempSelectedRange);
    if (onPriceFilterChange) onPriceFilterChange(tempSelectedRange);
    handleMenuClose();
  };

  const clearPriceFilter = () => {
    setSelectedPriceRange(null);
    setTempSelectedRange(null);
    setCustomRange([0, 1000000000]);
    setSliderMax(1000000000);
    if (onPriceFilterChange) onPriceFilterChange(null);
    handleMenuClose();
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {/* Main Search Bar */}
      <Paper
        ref={paperRef}
        component="form"
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '30px',
          px: 1,
          backgroundColor: '#f2f5f7',
          border: '1px solid black',
          mx: 0.5,
          my: 0.5,
        }}
        onSubmit={(e) => e.preventDefault()}
      >
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'black' }}>
          <ArrowBackIosNewIcon />
        </IconButton>

        <InputBase
          inputRef={inputRef}
          sx={{ ml: 1, flex: 1, fontSize: '14px' }}
          placeholder="Search location..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={() => searchValue && setSuggestionsOpen(true)}
        />

        {searchValue && (
          <IconButton 
            onClick={() => {
              setSearchValue('');
              setSuggestionsOpen(false);
              setPredictions([]);
              
              localStorage.removeItem('savedSearchValue');
              localStorage.removeItem('selectedLocation');
              localStorage.removeItem('recentLocationSearches');
              
              setRecentSearches([]);
              
              if (onClear) onClear();
            }} 
            sx={{ color: 'black' }}
          >
            <Close fontSize="small" />
          </IconButton>
        )}
        
        <IconButton type="submit" sx={{ color: 'black' }}>
          <Search />
        </IconButton>

        {!hidePriceFilter && (
          <IconButton sx={{ color: 'black' }} onClick={handleTuneClick}>
            <Tune />
          </IconButton>
        )}
      </Paper>

      {/* Suggestions Dropdown - same as your existing code */}
      <Popper
        open={suggestionsOpen && predictions.length > 0}
        anchorEl={paperRef.current}
        placement="bottom-start"
        sx={{ zIndex: 1300, width: '100%', maxWidth: 480, mx: 'auto' }}
        modifiers={[
          {
            name: 'preventOverflow',
            enabled: true,
            options: { boundary: 'clippingParents' },
          },
          {
            name: 'offset',
            options: { offset: [0, 8] },
          },
        ]}
      >
        <ClickAwayListener onClickAway={() => setSuggestionsOpen(false)}>
          <Paper
            elevation={6}
            sx={{
              width: '100%',
              maxWidth: { xs: 'calc(100vw - 16px)', sm: 480 },
              mx: 'auto',
              borderRadius: '12px',
              overflow: 'hidden',
              mt: 0.5,
            }}
          >
            <List>
              {predictions.map((prediction, index) => (
                <ListItem
                  key={index}
                  button
                  onClick={() => handleSuggestionClick(prediction)}
                  sx={{ py: 1.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <LocationOn color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={prediction.description}
                    primaryTypographyProps={{ fontSize: '14px' }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>

      {/* Recent Searches Dropdown - same as your existing code */}
      {recentSearches.length > 0 && (
        <Popper
          open={suggestionsOpen && predictions.length === 0 && searchValue === ''}
          anchorEl={paperRef.current}
          placement="bottom-start"
          sx={{ zIndex: 1300, width: '100%', maxWidth: 480, mx: 'auto' }}
          modifiers={[
            {
              name: 'preventOverflow',
              enabled: true,
              options: { boundary: 'clippingParents' },
            },
            {
              name: 'offset',
              options: { offset: [0, 8] },
            },
          ]}
        >
          <ClickAwayListener onClickAway={() => setSuggestionsOpen(false)}>
            <Paper
              elevation={6}
              sx={{
                width: '100%',
                maxWidth: { xs: 'calc(100vw - 16px)', sm: 480 },
                mx: 'auto',
                borderRadius: '12px',
                overflow: 'hidden',
                mt: 0.5,
              }}
            >
              <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                Recent Searches
              </Typography>
              <List>
                {recentSearches.map((search, index) => (
                  <ListItem
                    key={index}
                    button
                    onClick={() => {
                      setSearchValue(search.name);
                      if (onPlaceSelected) onPlaceSelected(search);
                      setSuggestionsOpen(false);
                    }}
                    sx={{ py: 1.5 }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <LocationOn color="action" />
                    </ListItemIcon>
                    <ListItemText
                      primary={search.name}
                      secondary={search.address}
                      primaryTypographyProps={{ fontSize: '14px' }}
                      secondaryTypographyProps={{ fontSize: '12px' }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}

      {/* Price Filter Menu - same as your existing code */}
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{ 
          style: { 
            width: '380px', 
            maxHeight: '540px',
            padding: '8px 0' 
          } 
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
          Select Price Range
        </Typography>
        <Divider />

        <Box sx={{ px: 2, py: 2 }}>
          <Slider
            value={customRange}
            onChange={handleSliderChangeTemp}
            min={0}
            max={sliderMax}
            step={1000}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => formatPrice(value)}
            className="MuiSlider-root"
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Typography variant="caption">{formatPrice(customRange[0])}</Typography>
            <Typography variant="caption">{formatPrice(customRange[1])}</Typography>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ px: 2, py: 2 }}>
          <Box sx={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: 1,
            maxHeight: '300px',
            overflowY: 'auto'
          }}>
            {currentRangeButtons.map((range, index) => (
              <Button
                key={range.label}
                variant={tempSelectedRange?.label === range.label ? 'contained' : 'outlined'}
                size="small"
                sx={{ 
                  borderRadius: '16px', 
                  textTransform: 'none', 
                  fontSize: '0.6rem',
                  minWidth: 'auto',
                  px: 1,
                  py: 0.5,
                  width: '90px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  ...(index === currentRangeButtons.length - 1 && {
                    width: '100%',
                    gridColumn: 'span 3',
                  }),
                }}
                onClick={() => handleRangeButtonSelect(range)}
              >
                {range.label}
              </Button>
            ))}
          </Box>
        </Box>

        <Divider />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
          <Button onClick={clearPriceFilter} color="error">
            CLEAR
          </Button>
          <Button onClick={handleApplyFilter} variant="contained" color="primary">
            APPLY
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default CustomSearchBar;